/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable object-curly-newline */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-void */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable arrow-body-style */
import React, { useState, useEffect } from "react";

import { NavigateFunction, useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Typography from "@mui/material/Typography";

import { CURRICULUM_STATUS_APPLYING_ATTEND, CURRICULUM_STATUS_DOING, CURRICULUM_STATUS_CANCEL_LEARN } from "../../../../Constants";

import NoData from "../../../../component/NoData";
import CurriculumCard from "../../../../component/card/CurriculumCard";
import { useScreenSize } from "../../../../component/Theme";
import SompoCardContent from "../../../../component/card/SompoCardContent";
import { calcDotsHeight } from "../../../../component/ReactSlickSettings";
import FilterTag, { ALL_CONDITION } from "../../../../component/filter/FilterTag";
import ConditionList from "../../../../component/ConditionList";
import SompoLoading from "../../../../component/loading/SompoLoading";
import type { Histories } from "../../Home";

import { OnGoingCULGridListItem } from "../../../../logic/api/OnGoingCULGridListService";
import SompoContext from "../../../../logic/context/SompoContext";
import { DateFormats, parseJSDateTime } from "../../../../logic/datetime";
import { Categories, CATEGORY_ID_CURRICULUMS } from "../../../../logic/hook/useCategories";
import { replaceCurriculaStatus } from "../../../../logic/utility/replaceLabels";
import { descDate } from "../../../../logic/utility/sort";
import { statusMatches } from "../../../../logic/utility/TrainingUtil";

import ScrollableGrid from "./ScrollableGrid";
import SompoHistoryCarousel, { ROWS } from "./SompoHistoryCarousel";

const navigateToCurriculumDetail = (navigator: NavigateFunction, careerId: string) => {
    return () => navigator(`/curriculum/detail/${careerId}`);
};

// 講座ラジオボタン：ステータス種別
const StatusType = {
    // すべて
    ALL: "0",

    // 申請中
    APPLYING: "1",

    // 受講中
    DOING: "2",
};

const CurriculumPaper = (props: { navigator: NavigateFunction; curriculum: OnGoingCULGridListItem; sx: object }) => {
    const { navigator, curriculum, sx } = props;

    // #19063: カード下部に出すステータスの差し替え
    const status = React.useMemo(() => replaceCurriculaStatus(curriculum.status), [curriculum.status]);

    return (
        <>
            <Paper elevation={1} sx={sx}>
                <CurriculumCard
                    tooltip={curriculum.careerTitle}
                    badge={curriculum.compulsoryId}
                    onClick={navigateToCurriculumDetail(navigator, curriculum.careerId)}
                >
                    <SompoCardContent
                        sx={{
                            height: "175px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            textAlign: "left",
                            gap: 0.4,
                        }}
                    >
                        <Box>
                            <Typography
                                sx={{
                                    width: "100%",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    minHeight: "2lh",
                                    wordBreak: "break-all",
                                    overflowX: "hidden",
                                }}
                                className="ellipses2"
                            >
                                {curriculum.careerTitle}
                            </Typography>
                        </Box>
                        <Box>
                            <Typography variant="body2">カリキュラム</Typography>
                            <Typography variant="body2">{`${curriculum.credit || "0/0"}単位`}</Typography>
                            <Typography variant="body2">{status}</Typography>
                        </Box>
                    </SompoCardContent>
                </CurriculumCard>
            </Paper>
        </>
    );
};

const filterByCategory = (curriculum: OnGoingCULGridListItem, categories: Categories, filterValue: string) => {
    // ALL：全表示
    if (filterValue === ALL_CONDITION.id) return true;

    // フィルタリング：カテゴリ
    const { careerId } = curriculum;
    const { getMainCategoryCurriculum } = categories;
    const rootCategory = getMainCategoryCurriculum(careerId);
    return rootCategory && filterValue === rootCategory.id;
};
const filterByStatus = (curriculum: OnGoingCULGridListItem, filterValue: string) => {
    const { statusId = "" } = curriculum;
    switch (filterValue) {
        // 申請中
        case StatusType.APPLYING:
            return statusMatches(statusId, [
                CURRICULUM_STATUS_APPLYING_ATTEND, // 受講申請中
                CURRICULUM_STATUS_CANCEL_LEARN, // 受講取消
            ]);
        // 受講中
        case StatusType.DOING:
            return statusId === CURRICULUM_STATUS_DOING;
        // すべて
        default:
            return true;
    }
};
const filterCurriculums = (curriculums: { onGoing: OnGoingCULGridListItem[] }, categories: Categories, categoryValue: string, statusValue: string) =>
    curriculums.onGoing
        .filter(
            (curriculum) =>
                // フィルタリング: カテゴリ + ステータス
                filterByCategory(curriculum, categories, categoryValue) && filterByStatus(curriculum, statusValue)
        )
        .sort((a, b) => {
            // ソート: 表示期間開始日(降順)
            const dateA = parseJSDateTime(a.displayStartDateTime, DateFormats.YYYYMMDDHHMM);
            const dateB = parseJSDateTime(b.displayStartDateTime, DateFormats.YYYYMMDDHHMM);
            return descDate(dateA, dateB);
        });

const CurriculumOnGoing = (props: { categories: Categories; histories: Histories }) => {
    // Context.
    const sompoContext = React.useContext(SompoContext); // ローディングアニメーションの表示用

    // Props.
    const { categories, histories } = props;
    // console.log("CurriculumOnGoingタブ: histories", histories.curriculums);
    const { getLevelCategoriesCurriculum } = categories;
    const filters = ConditionList(getLevelCategoriesCurriculum(CATEGORY_ID_CURRICULUMS));

    // Hooks.
    const navigate = useNavigate();
    const { desktop } = useScreenSize();

    // States.
    const [curriculums, setCurriculums] = useState<OnGoingCULGridListItem[]>([]);
    const [category, setCategory] = React.useState(ALL_CONDITION.id);
    const [status, setStatus] = React.useState(StatusType.DOING); // ラジオボタン(初期値は受講中)

    // Event Handlers.
    // カテゴリ変更
    const handleCategoryChanged = (name: string, id: string) => {
        setCategory(id);
    };

    // ステータス変更
    const handleStatusChanged = (event: { target: { value: string } }) => {
        const target = event.target.value;
        setStatus(target);
    };

    // カルーセルのドット数に応じて表示領域を可変にするために使用
    const carouselContainerHeight = calcDotsHeight(660, curriculums.length, ROWS);

    // Effects.
    useEffect(() => {
        const _curriculums = filterCurriculums(histories.curriculums, categories, category, status);
        setCurriculums(_curriculums);
    }, [category, status]);

    return (
        <>
            <Box
                sx={{
                    width: "100%",
                    height: "auto",
                }}
            >
                <FilterTag conditionList={filters} value={category} handleChange={handleCategoryChanged} />
                <Grid item>
                    <FormControl
                        sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: "left",
                        }}
                    >
                        <RadioGroup row defaultValue={StatusType.ALL} value={status} onChange={handleStatusChanged}>
                            <FormControlLabel
                                value={StatusType.ALL}
                                control={<Radio size="small" />}
                                label={<Typography variant="body2">すべて</Typography>}
                            />
                            <FormControlLabel
                                value={StatusType.APPLYING}
                                control={<Radio size="small" />}
                                label={<Typography variant="body2">申請中</Typography>}
                            />
                            <FormControlLabel
                                value={StatusType.DOING}
                                control={<Radio size="small" />}
                                label={<Typography variant="body2">受講中</Typography>}
                            />
                        </RadioGroup>
                    </FormControl>
                </Grid>
                {/* fetchが終わるまでローディングアイコンを表示 */}
                {sompoContext.loading ? (
                    <SompoLoading mt={5} position="relative" />
                ) : (
                    <ScrollableGrid>
                        {(curriculums || []).length ? (
                            desktop ? (
                                <>
                                    {curriculums.map((curriculum) => (
                                        <CurriculumPaper
                                            key={`CurriculumOnGoing-Paper-${curriculum.careerId}`}
                                            navigator={navigate}
                                            curriculum={curriculum}
                                            sx={{ mr: 1 }}
                                        />
                                    ))}
                                </>
                            ) : (
                                <Grid sx={{ width: "100%", height: carouselContainerHeight, margin: "0 auto" }}>
                                    <SompoHistoryCarousel
                                        careers={curriculums.map((curriculum) => (
                                            <CurriculumPaper
                                                navigator={navigate}
                                                curriculum={curriculum}
                                                sx={{
                                                    mr: 1,
                                                    mb: 1,
                                                    pb: 1,
                                                    width: { xs: "160px", sx: "160px", md: "215px" },
                                                    minWidth: { xs: "160px", sx: "160px", md: "215px" },
                                                    maxWidth: { xs: "160px", sx: "160px", md: "215px" },
                                                }}
                                            />
                                        ))}
                                    />
                                </Grid>
                            )
                        ) : (
                            <NoData message="表示データがありません" />
                        )}
                    </ScrollableGrid>
                )}
            </Box>
        </>
    );
};

export default CurriculumOnGoing;
